module.exports = __webpack_public_path__ + "fa-light-300.0d5e9bb82917c5d65c72.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-light-300.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-light-300.ttf
// module chunks = styles